import { render, staticRenderFns } from "./OverwriteLangAlias.vue?vue&type=template&id=708cb6cf&scoped=true&"
import script from "./OverwriteLangAlias.vue?vue&type=script&lang=js&"
export * from "./OverwriteLangAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cb6cf",
  null
  
)

export default component.exports